import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { shape, string, arrayOf, number, func, bool, oneOfType } from 'prop-types';
import { ArrowRight } from '@magalu/stereo-ui-icons';
import { Title, ProtectLabel, ServicesPriority, RobberyAndTheftLabel, ExtendedWarrantyLabel, ExtendedWarrantyRegulationTitle, ExtendedWarrantyRegulation, RobberyRegulationTitle, RobberyRegulation, ConciseMessage, Conditions, PaymentsWayLabel } from './financial-services.data';
import RobberyTheft from './RobberyAndTheft';
import ExtendedWarranty from './ExtendedWarranty';
import CertainExchange from './CertainExchange';
import { SidebarHeader, Wrapper, ProductImage, ProductMiniatureContent, ProtectProduct, Separator, TermItem, RegulationText, ConciseText } from './financial-services.styles';
import { Sidebar } from '../../organisms';
import { Strip, Button } from '../../atoms';
import { sortServices } from '../../utils';
import { filterBySelectedServices, isServicesSelected, selectedServicesId } from './helpers';
import TermsSidebar from './TermsSidebar';

const FinancialServices = _ref => {
  var _installment$quantity;

  let {
    installment,
    services,
    servicesPriority,
    onContinueClick,
    visible,
    timeTransition,
    onCloseClick,
    protectLabelAs,
    onChange,
    showCloseButton
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["installment", "services", "servicesPriority", "onContinueClick", "visible", "timeTransition", "onCloseClick", "protectLabelAs", "onChange", "showCloseButton"]);

  const RobberyAndTheftId = 'robberyAndTheft';
  const ExtendedWarrantyId = 'extendedWarranty';
  const CertainExchangeId = 'certainExchange';
  const [showRobberyTerm, setShowRobberyTerm] = useState(false);
  const [showExtendedWarrantyTerm, setShowExtendedWarrantyTerm] = useState(false);
  const [showPaymentsWay, setShowPaymentsWay] = useState(false);
  const [servicesSelected, setServiceSelected] = useState({
    [RobberyAndTheftId]: [],
    [ExtendedWarrantyId]: [],
    [CertainExchangeId]: []
  });
  const {
    records
  } = services;
  const installmentQuantity = (_installment$quantity = installment == null ? void 0 : installment.quantity) !== null && _installment$quantity !== void 0 ? _installment$quantity : null;
  const [robberyAndTheft, extendedWarranty, certainExchange] = sortServices(records, servicesPriority);

  const handleRobberyOptionsChange = (item, checked) => {
    const newValue = checked ? servicesSelected[RobberyAndTheftId].filter(serviceItem => (serviceItem == null ? void 0 : serviceItem.id) !== (item == null ? void 0 : item.id)) : servicesSelected[RobberyAndTheftId].concat(item);
    onChange(filterBySelectedServices(Object.assign({}, servicesSelected, {
      [RobberyAndTheftId]: newValue
    })));
    setServiceSelected(Object.assign({}, servicesSelected, {
      [RobberyAndTheftId]: newValue
    }));
  };

  const handleCommonService = (e, item, type) => {
    const newValue = [item];
    onChange(filterBySelectedServices(Object.assign({}, servicesSelected, {
      [type]: (item == null ? void 0 : item.value) === null ? [] : newValue
    })));
    setServiceSelected(Object.assign({}, servicesSelected, {
      [type]: (item == null ? void 0 : item.value) === null ? [] : newValue
    }));
  };

  const handleContinue = () => {
    if (selectedServicesId(servicesSelected).length) {
      onContinueClick(filterBySelectedServices(servicesSelected));
    } else {
      onContinueClick(null);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Sidebar, _extends({
    visible: visible,
    direction: "right",
    timeTransition: timeTransition,
    fullScreen: true
  }, props), /*#__PURE__*/React.createElement(Strip, null), /*#__PURE__*/React.createElement(SidebarHeader, {
    leftButton: {
      icon: 'close',
      title: 'fechar serviços financeiros',
      onClick: onCloseClick,
      iconColor: '#fefefe'
    },
    label: Title,
    showCloseButton: showCloseButton
  }), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ProductMiniatureContent, null, /*#__PURE__*/React.createElement(ProductImage, {
    src: services.image,
    width: 60,
    height: 60,
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(ProtectProduct, {
    as: protectLabelAs
  }, ProtectLabel)), /*#__PURE__*/React.createElement(RobberyTheft, {
    service: robberyAndTheft,
    "data-testid": "roubo-furto",
    onChange: handleRobberyOptionsChange,
    installmentQuantity: installmentQuantity
  }), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(CertainExchange, {
    service: certainExchange,
    "data-testid": "troca-certa",
    onChange: (e, item) => handleCommonService(e, item, CertainExchangeId),
    installmentQuantity: installmentQuantity
  }), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(ExtendedWarranty, {
    service: extendedWarranty,
    "data-testid": "garantia-estendida",
    onChange: (e, item) => handleCommonService(e, item, ExtendedWarrantyId),
    installmentQuantity: installmentQuantity
  }), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "financial-services-submit",
    m: '10px 0',
    color: "secondary",
    width: '100%',
    fontSize: 1,
    onClick: handleContinue,
    full: true
  }, isServicesSelected(servicesSelected) ? 'Contratar serviço e ir para sacola' : 'Ir para sacola'), /*#__PURE__*/React.createElement(Separator, null), !!selectedServicesId(servicesSelected).length && /*#__PURE__*/React.createElement(ConciseText, null, ConciseMessage, " ", /*#__PURE__*/React.createElement("b", null, Conditions)), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(TermItem, {
    onClick: () => setShowRobberyTerm(true),
    "data-testid": "robbery-theft-term-item"
  }, /*#__PURE__*/React.createElement("p", null, RobberyAndTheftLabel), /*#__PURE__*/React.createElement(ArrowRight, {
    width: "12px",
    height: "12px"
  })), /*#__PURE__*/React.createElement(TermItem, {
    onClick: () => setShowExtendedWarrantyTerm(true),
    "data-testid": "extended-warranty-term-item"
  }, /*#__PURE__*/React.createElement("p", null, ExtendedWarrantyLabel), /*#__PURE__*/React.createElement(ArrowRight, {
    width: "12px",
    height: "12px"
  })), !!selectedServicesId(servicesSelected).length && /*#__PURE__*/React.createElement(TermItem, {
    onClick: () => setShowPaymentsWay(true),
    "data-testid": "payments-way-term-item"
  }, /*#__PURE__*/React.createElement("p", null, PaymentsWayLabel), /*#__PURE__*/React.createElement(ArrowRight, {
    width: "12px",
    height: "12px"
  })), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(RegulationText, {
    fontSize: 0,
    fontWeight: "medium"
  }, ExtendedWarrantyRegulationTitle), /*#__PURE__*/React.createElement(RegulationText, {
    fontSize: 0,
    color: "scratched"
  }, ExtendedWarrantyRegulation), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(RegulationText, {
    fontSize: 0,
    fontWeight: "medium"
  }, RobberyRegulationTitle), /*#__PURE__*/React.createElement(RegulationText, {
    fontSize: 0,
    color: "scratched"
  }, RobberyRegulation))), /*#__PURE__*/React.createElement(TermsSidebar, {
    servicesSelected: servicesSelected,
    showRobberyTerm: showRobberyTerm,
    setShowRobberyTerm: setShowRobberyTerm,
    showExtendedWarrantyTerm: showExtendedWarrantyTerm,
    setShowExtendedWarrantyTerm: setShowExtendedWarrantyTerm,
    showPaymentsWay: showPaymentsWay,
    setShowPaymentsWay: setShowPaymentsWay
  }));
};

process.env.NODE_ENV !== "production" ? FinancialServices.propTypes = {
  installment: shape({
    amount: oneOfType([string, number])
  }),
  services: shape({
    image: string,
    records: arrayOf(shape({
      items: arrayOf(shape({
        id: oneOfType([string, number]),
        description: string
      })),
      description: string
    }))
  }),
  servicesPriority: arrayOf(number),
  visible: bool,
  timeTransition: number,
  protectLabelAs: string,
  onContinueClick: func,
  onCloseClick: func,
  onChange: func,
  showCloseButton: bool
} : void 0;
FinancialServices.defaultProps = {
  installment: {
    quantity: null
  },
  services: {
    image: ''
  },
  visible: true,
  timeTransition: 0.3,
  servicesPriority: ServicesPriority,
  protectLabelAs: 'p',
  onContinueClick: () => ({}),
  onCloseClick: () => ({}),
  onChange: () => ({}),
  showCloseButton: true
};
export default FinancialServices;